export default {"src":"/_next/static/media/logo.dc5fdb74.svg","height":47,"width":223};